/* eslint-disable no-case-declarations */

import {
  LOADING_STATISTICS,
  LOADING_STATISTICS_SUCCESS,
  LOADING_STATISTICS_ERROR,

  ADDING_STATISTIC,
  ADDING_STATISTIC_SUCCESS,
  ADDING_STATISTIC_ERROR,

  UPDATING_STATISTIC,
  UPDATING_STATISTIC_SUCCESS,
  UPDATING_STATISTIC_ERROR,

  DELETING_STATISTIC,
  DELETING_STATISTIC_SUCCESS,
  DELETING_STATISTIC_ERROR,

  FINDING_ADVERTISE_LOGS,
  FINDING_ADVERTISE_LOGS_SUCCESS,
  FINDING_ADVERTISE_LOGS_ERROR,

  DELETING_ADVERTISE_LOGS,
  DELETING_ADVERTISE_LOGS_SUCCESS,
  DELETING_ADVERTISE_LOGS_ERROR,

  FINDING_TAXI_LOGS,
  FINDING_TAXI_LOGS_SUCCESS,
  FINDING_TAXI_LOGS_ERROR,

  DELETING_TAXI_LOGS,
  DELETING_TAXI_LOGS_SUCCESS,
  DELETING_TAXI_LOGS_ERROR,

  FINDING_CLIENT_LOGS,
  FINDING_CLIENT_LOGS_SUCCESS,
  FINDING_CLIENT_LOGS_ERROR,

} from '../actions/statistics';

const initialState = {
  statisticList: [],
  advertiseLogList: [],
  taxiLogList: [],
  clientLogList: [],
  statistics_total: 0,
  loading: false,
  find_statistics_loading: false,
};
  
const StatisticsReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADING_STATISTICS:
        return { ...state, loading: true };
  
      case LOADING_STATISTICS_SUCCESS:
        return {
          ...state,
          loading: false,
          statisticList: action.payload,
        };

      case ADDING_STATISTIC:
        return { ...state, loading: true };
  
      case ADDING_STATISTIC_SUCCESS:
        return {
          ...state,
          loading: false,
          statisticList: [...state.statisticList, action.payload],
        };

      case UPDATING_STATISTIC:
        return { ...state, loading: true };
  
      case UPDATING_STATISTIC_SUCCESS:
        return {
          ...state,
          loading: false,
          statisticList: [...state.statisticList.map((obj) => {
            return action.payload.id === obj.id ? action.payload : obj;
          })]
        };

      case DELETING_STATISTIC:
        return { ...state, loading: true };
  
      case DELETING_STATISTIC_SUCCESS:
        return {
          ...state,
          loading: false,
          statisticList: [...state.statisticList.filter((obj) => {
            const findObj = action.payload.find(removedStatistic => (removedStatistic.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };


      case FINDING_ADVERTISE_LOGS:
        return { ...state, find_statistics_loading: true };
  
      case FINDING_ADVERTISE_LOGS_SUCCESS:
        return {
          ...state,
          find_statistics_loading: false,
          statistics_total: action.payload.find_total,
          advertiseLogList: action.payload.find_logs,
        };
  

      case DELETING_ADVERTISE_LOGS:
        return { ...state, loading: true };
  
      case DELETING_ADVERTISE_LOGS_SUCCESS:
        return {
          ...state,
          loading: false,
          advertiseLogList: action.payload,
        };

      case FINDING_TAXI_LOGS:
        return { ...state, find_statistics_loading: true };
  
      case FINDING_TAXI_LOGS_SUCCESS:
        return {
          ...state,
          find_statistics_loading: false,
          statistics_total: action.payload.find_total,
          taxiLogList: action.payload.find_logs,
        };
  

      case DELETING_TAXI_LOGS:
        return { ...state, loading: true };
  
      case DELETING_TAXI_LOGS_SUCCESS:
        return {
          ...state,
          loading: false,
          taxiLogList: action.payload,
        };

      case FINDING_CLIENT_LOGS:
        return { ...state, find_statistics_loading: true };
  
      case FINDING_CLIENT_LOGS_SUCCESS:
        return {
          ...state,
          find_statistics_loading: false,
          statistics_total: action.payload.find_total,
          clientLogList: action.payload.find_logs,
        };

      default:
        return state;
    }
  };
  
  export default StatisticsReducer;
  